export const useNewCard = () => {
  // const { loading, callRequest: addCardHandler } = useAxios({
  //   method: AxiosMethodMap.post,
  //   url: requestUrl(),
  //   body: {},
  //   onSuccess: data => {
  //     window.open(data.url, 'new_card', 'width=580,height=750');
  //   },
  //   onError: error => console.log('Request error:', error),
  // });

  const addCardHandler = () => {
    console.log('addCardHandler');
  };
  const loading = false;

  return {
    addCardHandler,
    loading,
  };
};
